<template>
  <div class="col-xl-4 xl-100">
    <px-card title="Top customers">
      <div class="card-body p-0">
        <template v-if="items.length">
          <div
            class="d-flex align-items-center px-3 py-2 border-bottom"
            v-for="customer in items"
            :key="customer.email || customer.name"
          >
            <div
              class="align-self-center text-center mr-2"
              style="width:36px;height:36px;border-radius:100%;background-color:#f4f4f4;display:flex;align-items:center;justify-content:center;flex-shrink:0;"
            >
              <feather type="user" style="width:16px;height:16px;color:#4680ff;"></feather>
            </div>
            <div class="flex-grow-1 mr-2" style="min-width:0;">
              <div class="text-truncate" style="font-weight:600;" :title="customer.name">
                {{ customer.name || "—" }}
              </div>
              <small class="text-muted text-truncate d-block" :title="customer.email">
                {{ customer.email || formatNumber(customer.count) + " order(s)" }}
              </small>
            </div>
            <div class="text-right">
              <div>{{ formatMoney(customer.spent, stats.currencySymbol) }}</div>
              <small class="text-muted">{{ formatNumber(customer.count) }} order(s)</small>
            </div>
          </div>
        </template>
        <div v-else class="text-center p-4 text-muted">
          No customers for this store yet.
        </div>
      </div>
    </px-card>
  </div>
</template>

<script>
import { formatMoney, formatNumber } from "../../../utils/store-stats";

export default {
  name: "top-customers-list",
  props: {
    stats: { type: Object, required: true }
  },
  computed: {
    items() {
      return this.stats.topCustomers || [];
    }
  },
  methods: {
    formatMoney,
    formatNumber
  }
};
</script>

<style></style>
